import { cn } from '@/lib/cn';

type Props = {
  className?: string;
  alt?: string;
  /** Decorative use - hides from a11y. */
  decorative?: boolean;
  /** Wraps in a hover-aware <span> with a subtle lift+glow. */
  interactive?: boolean;
};

/**
 * Bliss wordmark + roof emblem. Serves WebP first (smaller), with PNG fallback
 * for older browsers. Loads eagerly because it's in the header.
 */
export function Logo({
  className,
  alt = 'Bliss Building Contractors',
  decorative,
  interactive,
}: Props) {
  const img = (
    <picture>
      <source srcSet="/logo.webp" type="image/webp" />
      <img
        src="/logo.png"
        alt={decorative ? '' : alt}
        aria-hidden={decorative ? 'true' : undefined}
        className={cn(
          'h-auto w-auto select-none transition duration-500 ease-out',
          interactive && 'group-hover:-translate-y-0.5 group-hover:scale-[1.04] group-hover:drop-shadow-[0_8px_20px_rgba(201,168,106,0.35)]',
          className,
        )}
        loading="eager"
        decoding="async"
        draggable={false}
      />
    </picture>
  );

  if (!interactive) return img;

  return (
    <span className="group relative inline-flex items-center">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 rounded-full bg-gold-400/0 blur-2xl transition duration-500 group-hover:bg-gold-400/20"
      />
      {img}
    </span>
  );
}
